import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import {
  getStrategyDashboardPageTitleKey,
  shouldShowStrategyDashboardSignals,
  STRATEGY_DASHBOARD_TABS
} from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import {
  StrategyDashboardProvider,
  useStrategyDashboardConfig
} from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import PageTitle from "../../../common/PageTitle";
import RequirePlanPermission from "../../../common/RequirePlanPermission";
import LandingTypography from "../../../landingPage/components/LandingTypography";
import StrategyDashboardDescriptionTab from "../components/StrategyDashboardDescriptionTab";
import StrategyDashboardOverview from "../components/StrategyDashboardOverview";
import StrategyDashboardSignalsTab from "../components/StrategyDashboardSignalsTab";
import StrategyDashboardTableTab from "../components/StrategyDashboardTableTab";

const StrategyDashboardGatedContent = ({ tab, translate }) => {
  const dashboard = useStrategyDashboardConfig();

  const shouldRenderSignalsTab =
    tab === STRATEGY_DASHBOARD_TABS.SIGNALS &&
    (!dashboard.signalsTable ||
      shouldShowStrategyDashboardSignals(dashboard));

  return (
    <RequirePlanPermission permissions={dashboard.planPermissionSection}>
      <div>
        <PageTitle
          title={translate(getStrategyDashboardPageTitleKey(dashboard, tab))}
        />
        <LandingTypography className="landing-typography_dark flex flex-col gap-3">
          {tab === STRATEGY_DASHBOARD_TABS.TABLE ? (
            <StrategyDashboardTableTab />
          ) : shouldRenderSignalsTab ? (
            <StrategyDashboardSignalsTab />
          ) : tab === STRATEGY_DASHBOARD_TABS.DESCRIPTION ? (
            <StrategyDashboardDescriptionTab />
          ) : (
            <StrategyDashboardOverview />
          )}
        </LandingTypography>
      </div>
    </RequirePlanPermission>
  );
};

const StrategyDashboardPage = ({ translate, strategyId, tab = null }) => {
  return (
    <StrategyDashboardProvider strategyId={strategyId}>
      <StrategyDashboardGatedContent tab={tab} translate={translate} />
    </StrategyDashboardProvider>
  );
};

export default withTranslations(StrategyDashboardPage);
